import { Organization, profileContactModel } from './organization.model';

export class OrganizationUserModel {
    userId: string;
    organisationID: string;
    license: UserLicense;
    securityLevelID: string;
    securityRoleID: string;
    profileContact: profileContactModel;
    securityRoles: SecurityRoles[];
    organisation: Organization;
}

export class UserLicense {
    licenseType: LicenseType;
    licenseId: string;
    instanceTypeIndex: number;
    startDate: string;
    endDate: string;
}

export class LicenseType {
    licenseTypeId: string;
    name: string;
}

export class SecurityRoles {
    userSecurityRoleId?: string;
    securityRole: SecurityRole;
    userId?: string;
}

export class SecurityRole {
    securityRoleId: string;
    organisationId?: string;
    name: string;
    description?: string;
    isDerivedFromTemplate?: boolean;
}

// export class AddUserModel {
//   userID:string;
//   organisationID:string;
//   securityLevel:SecurityLevels;
//   securityUserType:string;
// }
export class ADB2CUser {
    userId: string;
    userEmail: string;
    firstName: string;
    lastName: string;
}

export class UserModelForDisplayData {
    userId: string;
    firstName: string;
    lastName: string;
    userEmail: string;
    securityRoleName: string;
}

export class SecurityRoleUser {
    secuirtyRoleName: string;
    usersList: UserModelForDisplayData[];
}
